import controller from './contacts.controller';

const template = require('./contacts.html');

export default {
    selector: 'alertContacts',
    options: {
        controller,
        template
    }
}; 